module.exports = __webpack_public_path__ + "img/1440.04f497ae.jpg";